import * as swcHelpers from '@swc/helpers';
import { areSameContactLenses } from './line-item-matchers/contact-lenses/are-same-contact-lenses.js';
import { areSameNonPrescriptionBundleLineItem } from './line-item-matchers/non-rx-bundle/are-same-non-prescription-bundle.js';
import { areSamePrescriptionGlassesLineItem } from './line-item-matchers/prescription-glasses/prescription-glasses-bundle.js';
import { areSameRegularProduct } from './line-item-matchers/regular/are-same-regular-product.js';

const sameProduct = (serverLineItem, draft)=>{
    switch(draft.type){
        case 'contact-lenses-bundle-benelux':
        case 'contact-lenses-subscription':
            return serverLineItem.sku === draft.sku;
        case 'regular':
            return areSameRegularProduct(serverLineItem, draft);
        case 'non-prescription-bundle':
            return areSameNonPrescriptionBundleLineItem(serverLineItem, draft);
        case 'prescription-glasses':
            // A LineItemBundle is considered the same product only when all SKUs match exactly
            return areSamePrescriptionGlassesLineItem(serverLineItem, draft);
        case 'contact-lenses':
            // CL drafts should already be matched by the check above
            return areSameContactLenses(serverLineItem, draft);
        case 'insurance':
            return false;
    }
};
const getAddedLineItems = (lineItemsInCart, newLineItems)=>{
    return lineItemsInCart.reduce((m, cartLineItem)=>{
        const matchingCartLineItem = newLineItems.find(sameProduct.bind(null, cartLineItem));
        if (!matchingCartLineItem) {
            /**
       * We only want to keep cart line items we can match to a draft line
       * item that was just added.
       */ return m;
        }
        var ref;
        const quantity = (ref = matchingCartLineItem === null || matchingCartLineItem === void 0 ? void 0 : matchingCartLineItem.quantity) !== null && ref !== void 0 ? ref : 1;
        if (cartLineItem.quantity === quantity) {
            /**
       * No need to recalculate pricing if the quantities are the same.
       */ return [
                ...m,
                cartLineItem
            ];
        }
        /**
     * We need quantity and total pricing based on the products that were
     * just added, excluding products that already existed in the cart.
     */ return [
            ...m,
            swcHelpers.objectSpread({}, cartLineItem, {
                quantity,
                price: getTotalPricePerAddedQuantity(cartLineItem.price, quantity)
            }), 
        ];
    }, []);
};
// Overwrite total pricing based on unit price * quantity
const getTotalPricePerAddedQuantity = (price, quantity)=>{
    return swcHelpers.objectSpread({}, price, {
        total: swcHelpers.objectSpread({}, price.total, {
            gross: price.unit.gross * quantity,
            net: price.unit.net * quantity,
            subtotal: price.unit.subtotal * quantity,
            discount: swcHelpers.objectSpread({}, price.total.discount, {
                amount: price.unit.discount.amount * quantity
            }),
            tax: swcHelpers.objectSpread({}, price.total.tax, {
                amount: price.unit.tax.amount * quantity,
                portions: price.unit.tax.portions.map((portion, index)=>{
                    var ref;
                    var ref1;
                    const amount = (ref1 = (ref = price.unit.tax.portions[index]) === null || ref === void 0 ? void 0 : ref.amount) !== null && ref1 !== void 0 ? ref1 : 0;
                    return swcHelpers.objectSpread({}, portion, {
                        amount: amount * quantity
                    });
                })
            })
        })
    });
};

export { getAddedLineItems };
//# sourceMappingURL=get-added-line-items.js.map
